import { post } from './config'

/**
 * 意见反馈
 */

export const feedbackAdd = (data) => post('/feedback/add', data)
